import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import store from './store'
import router from './router'
import * as VueGoogleMaps from 'vue2-google-maps'
//import VueMeta from 'vue-meta'

Vue.config.productionTip = false
Vue.config.ignoredElements = ['a-scene','a-sky','a-text','a-plane','a-camera','a-cursor', 'a-entity'];  

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBbiJlBN18QjMaR-Xfp0zs9Ps6mRzhcqOs',
    libraries: 'places,drawing,visualization',
  },
})

/*
Vue.use(VueMeta, {
  refreshOnceOnNavigation: true
})
*/

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#app')